export default __webpack_public_path__ + "static/media/job-switching-list.02b4d285.svg";